
import {WorkspaceItemType} from "../api/primatoo-ms-organization/workspace-item-type";

export class WorkspaceItemTypeConverter {
  static treatmentToResourceType(treatmentType?: 'HOLDER' | 'RESPONSIBLE' | 'PROJECT' | 'SUB_RESPONSIBLE'): WorkspaceItemType | null {
    switch (treatmentType) {
      case 'HOLDER':
        return WorkspaceItemType.TREATMENT_HOLDER;
      case 'RESPONSIBLE':
        return WorkspaceItemType.TREATMENT_RESPONSIBLE;
      case 'PROJECT':
        return WorkspaceItemType.TREATMENT_PROJECT;
      case 'SUB_RESPONSIBLE':
        return WorkspaceItemType.TREATMENT_SUB_RESPONSIBLE;
    }
    return null;
  }
}
